import { externalManufacturingActions } from "api/external-manufacturing/actions";
import { ExternalManufacturerLineItem } from "api/external-manufacturing/models";
import { UUID } from "api/types";
import { Table } from "components/miloDesignSystem/molecules/table";
import { comfortableListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { RightPanelSection } from "components/utils/drawer";
import { useFilters } from "hooks/useFilters";
import { useLineItemsColumns } from "./useLineItemsColumns";

interface Props {
  id: UUID;
}

export const LineItemsSection = ({ id }: Props) => {
  const { searchParams, setFilter } = useFilters({ page: 1, manufacturingOrder: id });
  const {
    data: lineItems,
    error,
    isLoading,
    isPreviousData,
    pagination,
  } = externalManufacturingActions.useManufacturerLineItems(searchParams);
  const columns = useLineItemsColumns() as ExternalManufacturerLineItem[];

  return (
    <RightPanelSection title="Lista pojedynczych">
      <div className="pb-3">
        <Table<ExternalManufacturerLineItem>
          rows={lineItems}
          columns={columns}
          onPaginationChange={paginationState => setFilter("page", paginationState.pageIndex)}
          isLoading={isLoading || isPreviousData}
          error={error}
          uiSchema={comfortableListUiSchema}
          pagination={(pagination?.count || 0) > 30 ? pagination : undefined}
        />
      </div>
    </RightPanelSection>
  );
};
